// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1PayloadStagePayloadStagePayloadResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1PayloadStagePayloadStagePayloadResponse.attributeTypeMap;
    }
}
PayloadStagingV1PayloadStagePayloadStagePayloadResponse.discriminator = undefined;
PayloadStagingV1PayloadStagePayloadStagePayloadResponse.additionalProperties = false;
PayloadStagingV1PayloadStagePayloadStagePayloadResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1PayloadStagePayloadStagePayloadResponse.js.map